import { createFileRoute, useParams } from '@tanstack/react-router';
import { emailStatsQueryOptions } from '@utils/queryOptions';
import EmailStats from '@Views/Emails/sent/details/stats-view';

export const Route = createFileRoute('/emails/(sent)/$emailId/$statType')({
    loader: opts =>
        opts.context.queryClient.ensureQueryData(
            emailStatsQueryOptions(opts.params.emailId, opts.params.statType),
        ),
    component: () => {
        const { statType } = useParams({});
        return <EmailStats key={statType} />;
    },
});
